import { Navigate } from "react-router-dom";

const GuardedRoute = ({
  isAllow,
  redirect = "/denied",
  children,
}: {
  isAllow: boolean;
  redirect?: string;
  children: JSX.Element;
}) => {
  return isAllow ? children : <Navigate to={redirect} replace />;
};

export default GuardedRoute;
